<template>
  <div class="mb-20">
    <HeaderBar :title="hTitle" />
    <div>
      <div class="text-justify my-2">
        The Registration Fee (RGF) is also known as the Title Transfer Fee. This
        is required for Moldex to process the transfer of both the Transfer
        Certificate Title and Tax Declaration from Moldex to your name.
      </div>
      <div class="my-2">
        <div class="my-2 font-bold">
          Basis of the Registration Fee computation:
        </div>
        <ul class="list-disc">
          <li>Total Contract Price</li>
          <li>Size of the property</li>
          <li>Current zonal value</li>
        </ul>
      </div>
      <div class="my-2">
        <div class="font-bold my-2">The Registration Fee may be paid:</div>
        <ul class="list-disc">
          <li>Together with the down payment</li>
          <li>Together with the monthly amortization</li>
          <li>Altogether on the last down payment</li>
          <li>After the full payment of the Total Contract Price</li>
        </ul>
      </div>

      <p>
        This will depend on your chosen payment terms indicated in your
        Reservation Agreement and Contract to Sell.
      </p>
      <p>
        The Registration Fee computation may change depending on the zonal value
        during the time you will complete the Deed of Absolute Sale
        requirements.The Registration Fee consists of the following:
      </p>

      <ul class="list-disc">
        <li>Documentary Stamp</li>
        <li>Transfer Tax</li>
        <li>Registration and IT Fees</li>
        <li>Annotation / Legal / Notarization Fees</li>
        <li>Administrative Fees</li>
      </ul>
    </div>
  </div>
</template>

<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  props: ["hTitle"],
  components: { HeaderBar },
};
</script>